import { render, staticRenderFns } from "./Paused.vue?vue&type=template&id=825f2b8a&scoped=true"
import script from "./Paused.vue?vue&type=script&lang=js"
export * from "./Paused.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825f2b8a",
  null
  
)

export default component.exports